import React from 'react';
import {
  Container,
  Grid,
  Header,
  Image,
} from 'semantic-ui-react';
import { getImageUrl } from '../../../utils/images';
import { truncateText } from '../../../utils/blocks';

interface FAQItem {
  question?: string;
  answer?: string;
}

interface FAQsViewData {
  backgroundImage?: string | null;
  header?: string;
  items?: FAQItem[];
}

interface FAQsViewProps {
  data?: FAQsViewData;
}

const FAQsView = ({ data = {} }: FAQsViewProps) => {
  const {
    backgroundImage = null,
    header = 'FREQUENTLY ASKED QUESTIONS',
    items = [],
  } = data;

  const imageUrl = getImageUrl(backgroundImage);

  return (
    <section
      className="faqs-block fullbleed"
      aria-label="Frequently asked questions"
    >
      <Container>
        <Grid
          stackable
          verticalAlign="middle"
        >
          <Grid.Row columns={2}>
            <Grid.Column widescreen={4} largeScreen={4} >
      
                <Image
                  src={imageUrl}
                  size='large'
                />
          
            </Grid.Column>

            <Grid.Column widescreen={4} largeScreen={7}>
              <div className="">
                <Header
                  as="h2"
                  dividing
                  textAlign="center"
                  className="faqs-title"
                >
                  {header}
                </Header>
                <Grid
                  stackable
                  columns={2}
                  className=""
                >
                  {items.map((item, idx) => (
                    <Grid.Column key={idx}>
                      <div className="faq-item">
                        <Header
                          as="h3"
                          className="faq-question"
                        >
                          {item.question}
                        </Header>

                        <p className="faq-answer">
                          {truncateText(item.answer, 150)}
                        </p>
                      </div>
                    </Grid.Column>
                  ))}
                </Grid>
              </div>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Container>
    </section>
  );
};

export default FAQsView;
